import * as React from "react";

import * as RadioGroupPrimitive from "@radix-ui/react-radio-group";
import { CircleIcon } from "lucide-react";

import { cn } from "@repo/ui/lib/utils";

function JetSmartRadioGroup({
  className,
  ...props
}: React.ComponentProps<typeof RadioGroupPrimitive.Root>) {
  return (
    <RadioGroupPrimitive.Root
      data-slot="radio-group"
      className={cn("grid gap-3", className)}
      {...props}
    />
  );
}

const fillClasses: Record<string, string> = {
  "brand-cyan": "fill-brand-cyan",
  "brand-blue": "fill-brand-blue",
};

const sizeClasses: Record<string, string> = {
  "3": "size-3",
  "4": "size-4",
};

function JetSmartRadioGroupItem({
  className,
  radioGroupDot = "brand-cyan",
  radioButtonDotSize = "3",
  checked,
  ...props
}: React.ComponentProps<typeof RadioGroupPrimitive.Item> & {
  radioButtonDotSize?: string;
  radioGroupDot?: string;
}) {
  return (
    <RadioGroupPrimitive.Item
      data-slot="radio-group-item"
      className={cn(
        "text-primary focus-visible:border-ring focus-visible:ring-ring/50 aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 dark:bg-input/30 aspect-square h-6 w-6 shrink-0 rounded-full border shadow-xs transition-[color,box-shadow] outline-none focus-visible:ring-[3px] disabled:cursor-not-allowed disabled:opacity-50",
        className,
      )}
      {...props}
    >
      {/* Used standalone (no JetSmartRadioGroup Root), so Radix's own context-driven
          `checked` (Root.value === Item.value) is never true. Force-mount and drive
          visibility off the `checked` prop the caller passes in instead. */}
      <RadioGroupPrimitive.Indicator
        forceMount
        data-slot="radio-group-indicator"
        className={cn(
          "relative flex items-center justify-center",
          checked ? "opacity-100" : "opacity-0",
        )}
      >
        <CircleIcon
          className={cn(
            `${fillClasses[radioGroupDot]} absolute top-1/2 left-1/2`,
            `${sizeClasses[radioButtonDotSize]}`,
            "-translate-x-1/2 -translate-y-1/2",
          )}
        />
      </RadioGroupPrimitive.Indicator>
    </RadioGroupPrimitive.Item>
  );
}

export { JetSmartRadioGroup, JetSmartRadioGroupItem };
